$(document).ready(function(){
    function showRecoverPasswordForm(event) {
      event.preventDefault();
      $('#recover_password1').show();
      $('#customer_login1').hide();
      _theme.focusFirstTabbable($('.recover_password-class'));
    }
    function hideRecoverPasswordForm(event) {
      event.preventDefault();
      $('#recover_password1').hide();
      $('#customer_login1').show();
      if($('.showRecoverPasswordForm')[0]) $('.showRecoverPasswordForm')[0].focus();
      else _theme.focusFirstTabbable($('form[action="/account/login"]'));
    }
    $('.showRecoverPasswordForm').on('click',showRecoverPasswordForm)
    $('.hideRecoverPasswordForm').on('click',hideRecoverPasswordForm)
    $('.wrapper-login-customer .wrapper-content .col-left .errors').attr({
      'role':'alert',
      'aria-live':'assertive'
    })
  })
  
  /*
    Show/hide the recover password form when requested.
    I'd suggest using some CSS3 transitions to make this change look cool,
    but this gets the job done for now.
  */
  $('#customer_login').each(function(i,e){
    $(this).addClass('custom_login-class');
    $(this).attr('id','customer_login'+(i+1))
  })
  $('#create_customer').each(function(i,e){
    $(this).addClass('create_customer-class');
    $(this).attr('id','create_customer'+(i+1))
  })
  $('#recover_password').each(function(i,e){
    $(this).addClass('recover_password-class');
    $(this).attr('id','recover_password'+(i+1))
  })
  function showRecoverPasswordForm() {
    $('.recover_password-class').show();
    $('.custom_login-class').hide();
  }

  function hideRecoverPasswordForm() {
    $('.recover_password-class').hide();
    $('.custom_login-class').show();
  }

  // Allow deep linking to the recover password form
  if (window.location.hash == '#recover') {
    showRecoverPasswordForm() 
  }